import { Input } from "@mui/material";
import React, { ChangeEvent } from "react";
import { FieldType, Unit } from "../../../services/helpers/types";
import { generateUnit } from "../../molecules/DoctorsReport/helpers";
import { useTranslation } from "react-i18next";

interface NumberFieldProps {
  field?: FieldType;
  value?: string;
  customUnit?: Unit;
  placeholder?: string;
  onChange: (value?: string) => void;
}

const NumberField = (props: NumberFieldProps) => {
  const { field, value = "", customUnit, placeholder, onChange } = props;

  const { t } = useTranslation();

  const unit = generateUnit(t, customUnit ?? field?.unit, value);

  const commaSeparator = {
    name: "comma",
    regex: /^\d+(,\d{0,10})?$/,
  };
  const dotSeparator = {
    name: "period",
    regex: /^\d+(\.\d{0,10})?$/,
  };

  const handleInputChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const currentValue = event.target.value;
    if (currentValue === "") {
      onChange(undefined);
    }
    if (
      commaSeparator.regex.test(currentValue) ||
      dotSeparator.regex.test(currentValue)
    ) {
      onChange(currentValue);
    }
  };

  return (
    <div className="dui-number-field">
      <Input
        className="dui-number-field-inner"
        onChange={handleInputChange}
        placeholder={placeholder ?? field?.placeholder}
        value={value ?? ""}
        endAdornment={<div className="dui-number-field-unit">{unit}</div>}
      />
    </div>
  );
};

export default NumberField;
